export enum ActivityPlannedBy {
	veeroute = 1,
	publicExchange = 2,
}
